import { CANCELLED_ORDER_FAILURE, CANCELLED_ORDER_REQUEST, CANCELLED_ORDER_SUCCESS, DELETE_ORDER_LIST_FAILURE, DELETE_ORDER_LIST_REQUEST, DELETE_ORDER_LIST_SUCCESS, GET_ORDER_LIST_FAILURE, GET_ORDER_LIST_REQUEST, GET_ORDER_LIST_SUCCESS, POST_ORDER_LIST_FAILURE, POST_ORDER_LIST_REQUEST, POST_ORDER_LIST_SUCCESS, PUT_ORDER_LIST_FAILURE, PUT_ORDER_LIST_REQUEST, PUT_ORDER_LIST_SUCCESS, RESET_TABLE_FLAGS } from "../../../Utils/Constant";

const initialState = {
    orderList: [],
    addOrder: {},
    loading: false,
    error: null,
    addSuccess: false,
    editSuccess: false,
    deleteSuccess: false,
};


export const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_ORDER_LIST_SUCCESS:
            return {
                ...state,
                orderList: action.payload,
                loading: false,
                error: null,
            };
        case GET_ORDER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // POST amenity
        case POST_ORDER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case POST_ORDER_LIST_SUCCESS:
            return {
                ...state,
                addOrder: action.payload,
                addSuccess: true,
                loading: false,
                error: null,
            };
        case POST_ORDER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                addSuccess: false,
                error: action.payload,
            };

        // DELETE amenity
        case DELETE_ORDER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case DELETE_ORDER_LIST_SUCCESS:
            return {
                ...state,
                deleteSuccess: true,
                loading: false,
                error: null,
            };
        case DELETE_ORDER_LIST_FAILURE:
            return {
                ...state,
                deleteSuccess: false,
                loading: false,
                error: action.payload,
            };

        case PUT_ORDER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case PUT_ORDER_LIST_SUCCESS:
            return {
                ...state,
                editSuccess: true,
                loading: false,
                error: null,
            };
        case PUT_ORDER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                editSuccess: false,
                error: action.payload,
            };

        case CANCELLED_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case CANCELLED_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case CANCELLED_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case RESET_TABLE_FLAGS:
            return {
                ...state,
                addSuccess: false,
                editSuccess: false,
                deleteSuccess: false,
            };

            
        default:
            return state;
    }
};
